import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { Link } from 'react-router-dom';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { withRouter } from 'src/node_modules/kts-platform-frame/routes';
import ModulesState from '../Modules.State';
import ModulesAction from '../Modules.Action';
import Icon from 'src/display/components/Icon';
import { Breadcrumb } from 'antd';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    expansion?: JSX.Element;
}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@withRouter
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        return (
            <div className={css.head} >
                <this.renderBreadcrumb />
                <this.renderTabs />
                {/* {this.props.expansion} */}
            </div>
        );
    }

    /** 面包屑 */
    renderBreadcrumb = () => {
        return (
            <div className={`clear ${css.breadcrumbContainer}`} >
                <Breadcrumb className={css.breadcrumb} separator={<img height="8" src={require('./img.arrow.svg')} alt=""/>}>
                    <Breadcrumb.Item>首页</Breadcrumb.Item>
                    <Breadcrumb.Item>应用管理</Breadcrumb.Item>
                </Breadcrumb>
                <div className={css.buttList} >
                    <a onClick={this.onClickBackHandler} >
                        <Icon width={18} height={18} color="#060001" src={require('./img.back.svg')} />
                    </a>
                </div>
            </div>
        );
    }

    /** 标签 */
    private renderTabs = () => {
        return (
            <div className={css.pageHeaderTitle}>
                <h1>应用管理</h1>
            </div>
            
        );
    }

    /** 搜索 */
    // private renderSearch = () => {
    //     return (
    //         <div className={css.search} >
    //             <Input
    //                 className={css.input}
    //                 placeholder="Search…"
    //                 prefix={<AIcon type="search" />}
    //             />
    //             <Link to="/list/sort" className={css.sort} >
    //                 <Icon src={require('./img.sort.svg')} width={24} height={24} color="#919191" />
    //             </Link>
    //         </div>
    //     );
    // }

    /** 点击了 会退 */
    private onClickBackHandler = () => {
        this.props.history.goBack();
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/UI.Head/index.tsx